"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var __1 = require("..");
var FeatureFlag = function (_a) {
    var name = _a.name, _b = _a.defaultValue, defaultValue = _b === void 0 ? false : _b, _c = _a.invert, invert = _c === void 0 ? false : _c, children = _a.children;
    var flagsClient = react_1.useContext(__1.FlagsContext);
    var flag = flagsClient ? flagsClient.getFlag(name) : undefined;
    var isEnabled = defaultValue;
    if (flag !== undefined) {
        isEnabled = invert ? !flag.enabled : flag.enabled;
    }
    return (react_1.default.createElement(react_1.Fragment, null, typeof children === 'function' ? children(flag) : isEnabled ? children : null));
};
exports.default = FeatureFlag;
//# sourceMappingURL=FeatureFlag.js.map